import React from 'react';
import 'whatwg-fetch';

import ModalConfirm from '../modal/modalConfirm';

export default class InputUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPropsReceived: false,
      isBlackOut: false,
      onUpdate: false,
      inputLabel: this.props.inputLabel ? this.props.inputLabel : null,
      inputValue: this.props.inputValue,
      inputValueSaved: this.props.inputValue,
      isModalConfirmOpen: false,
      textModal: {
        title: 'Confirmer modification',
        message: this.props.inputLabel
          ? 'Vous allez modifier "' + this.props.inputLabel + '"'
          : 'Vous allez modifier le champ',
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openConfirmModal = this.openConfirmModal.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.cancelUpdate = this.cancelUpdate.bind(this);
    this.submitUpdate = this.submitUpdate.bind(this);
  }

  handleInputChange(event) {
    let value = '';
    let name = 'inputValue';

    if ((event || {}).target) {
      const target = event.target;
      value = target.value;
      name = target.name;
    } else {
      value = event;
    }

    this.setState({
      [name]: value,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.onUpdate && nextProps.inputValue != this.props.inputValue) {
      // init or parent's routing with updated props.match.id
      this.setState({
        isPropsReceived: true,
        inputValue: nextProps.inputValue,
        inputValueSaved: nextProps.inputValue,
      });
    }
  }

  render() {
    const { inputLabel, inputValue, textModal, isModalConfirmOpen, onUpdate } = this.state;

    return (
      <div style={this.props.style} className='form-group'>
        {inputLabel && <label>{inputLabel}</label>}
        <div className='alignHorizontal'>
          {this.props.renderInput ? (
            this.props.renderInput({
              disabled: !onUpdate,
              value: inputValue,
              onChange: this.handleInputChange,
            })
          ) : (
            <input
              name='inputValue'
              value={inputValue}
              onChange={this.handleInputChange}
              type={this.props.inputType}
              className='form-control'
              placeholder='...'
              {...(!onUpdate && { readOnly: true })}
            />
          )}
          {onUpdate ? (
            <div className='alignHorizontal'>
              <button onClick={() => this.openConfirmModal()} type='button' className='btn btn-sm btn-outline-success'>
                <span className='icon icon-check' />
              </button>
              <button onClick={() => this.cancelUpdate()} type='button' className='btn btn-sm btn-outline-success'>
                <span className='icon icon-back' />
              </button>
            </div>
          ) : (
            <button onClick={() => this.onUpdate()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-brush' />
            </button>
          )}
        </div>

        <ModalConfirm
          className='myModal'
          modalText={textModal}
          isOpen={isModalConfirmOpen}
          onSubmit={() => this.submitUpdate()}
          onClose={() => this.closeModal()}
          onCancel={() => this.closeModal()}
        ></ModalConfirm>
      </div>
    );
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalConfirmOpen: false,
    });
  }

  openConfirmModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalConfirmOpen: true,
    });
  }

  onUpdate() {
    this.setState({
      inputValueSaved: this.state.inputValue,
      onUpdate: true,
    });
  }

  cancelUpdate() {
    this.setState({
      inputValue: this.state.inputValueSaved,
      onUpdate: false,
    });
  }

  submitUpdate() {
    this.setState({
      onUpdate: false,
    });
    this.props.submitUpdate(this.state.inputValue, this.props.inputType);
  }
}
